import(/* webpackMode: "eager" */ "/Users/sthony/Documents/Sthony/ailumix-web-current/apps/web/src/app/research/summary/page.tsx");
